/**
 *
 * Menu Top Nav
 *
 * Custom UI (rebrand)
 *
 * Date: 01/12/2020
 * Dev: Mirza Masic
 *
 */

const $        = require('jquery');

let TopNav = function( el ){

  //global variables

  this.$el        = $(el);
  this.$window    = $(window);
  this.$body      = $(document).find( 'body' );
  this.prev       = 0;
  this.$nav       = $('.js-scrollhide-nav');
  this.$container = $('.js-scrollhide-nav__container');
  this.$subNavs   = $('.itbl-c-sub-menu__wrapper');

  this.init();
};

TopNav.prototype.init = function() {

  this.initSubNavPositions();
  this.events();

};

TopNav.prototype.initSubNavPositions = function(){
  // check if header has class .itbl-c-nav__one-column-nav-items
  if (!this.$nav.hasClass('itbl-c-nav__one-column-nav-items')) {
    return;
  }

  // menu wrapper position
  let wrapperNavPos = $('.itbl-c-nav__menu-main').offset();

  //set the subnavs to the right of the nav
  this.$subNavs.each(function(){
    let $subNav = $(this);
    
    // get nav class from subnav id
    let navId = $subNav.attr('id').replace('sub-menu-', '');
    let $navClass = $('.menu-item-' + navId);

    // get left position of nav
    let navPos = $navClass.offset();
    let submenuLeftPos = navPos.left - wrapperNavPos.left;

    $subNav.css({
      left: submenuLeftPos,
    });
  });
}

TopNav.prototype.events = function() {
  this.$nav.mouseenter(this.event__logoHover.bind(this));

  this.$nav.mouseleave(this.event__logoLeave.bind(this));

  this.$window.on('scroll', this.event__handleScroll.bind(this));
};

TopNav.prototype.event__handleScroll = function() {
  let scroll = this.$window.scrollTop();

  if (scroll > 0) {
    this.$nav.addClass('is-scrolled');
  } else {
    this.$nav.removeClass('is-scrolled');
  }

  const positionBreadcrumbsEvent  = new CustomEvent('positionBreadcrumbs', {
    bubbles: true,
  });

  window.dispatchEvent(positionBreadcrumbsEvent);
};

TopNav.prototype.event__logoHover = function(){
  this.dispatchTopNav();
};

TopNav.prototype.event__logoLeave = function(){
  this.dispatchTopNav();
};

TopNav.prototype.dispatchTopNav = function(){
  this.event = new CustomEvent("itbl.menuScroll", {
    bubbles: true,
    detail: {
      topNavEl: this.$el,
    }
  });

  //fire custom event for anything that needs to know if the menu is visible
  document.dispatchEvent(this.event);

};

$(document).ready(function(){
  new TopNav('#main-nav');
});

